import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Zukunft = props => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <g fill="none" fillRule="evenodd">
      <circle fill="#FFA86A" cx="24" cy="24" r="24" />
      <g fill="#FFF" fillRule="nonzero">
        <path d="M30.5 35v-7.5H29V22c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5h-1.5V35h-4zM18 35v-6h3l-2.54-7.63c-.28-.82-1.04-1.37-1.9-1.37h-.12c-.86 0-1.63.55-1.9 1.37L12 29h3v6h3zm14.5-16c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2 .89-2 2 0 1.11.89 2 2 2zM16 19c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2 .89-2 2 0 1.11.89 2 2 2zM25.5914 35v-3.5424h1.7957l-1.5204-4.5048a1.2015 1.2015 0 0 0-1.1372-.8089h-.0719c-.5147 0-.9756.3248-1.1372.8089L22 31.4576h1.7957V35h1.7957zm-.8979-9.4465c.6645 0 1.1972-.5254 1.1972-1.1808 0-.6553-.5327-1.1808-1.1972-1.1808-.6644 0-1.197.5255-1.197 1.1808 0 .6554.5326 1.1808 1.197 1.1808z" />
      </g>
    </g>
  </SvgIcon>
);

export default Zukunft;
